import DropDownFilterCell from './BsrsGrid.DropDownFilterCell'
import getEnumTranslation from '@/enums/enums'

export default ({ localize, enumName }, enumValues = [], kendoProps = {}) => {
  const defaultItem = { value: -1, text: localize('Common.SelectValue') }
  const data = enumValues.map(x => ({ text: getEnumTranslation({ localize, enumName, value: x }), value: x }))

  return DropDownFilterCell(data, { textField: 'text', dataItemKey: 'value', defaultItem, ...kendoProps })
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.EnumFilterCell.js